import { useQuery } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { withError } from '@/react-tools/react-query';

import { RecommendationSummary } from './types';
import { queryKeys } from './queryKeys';

export async function getRecommendationsSummary(): Promise<RecommendationSummary> {
  try {
    const { data } = await axios.get<RecommendationSummary>(
      '/recommendations/summary'
    );
    return data;
  } catch (error) {
    throw parseAxiosError(error, 'Unable to retrieve recommendations summary');
  }
}

export function useRecommendationsSummary<TSelect = RecommendationSummary>({
  enabled = true,
  select,
}: {
  enabled?: boolean;
  select?: (data: RecommendationSummary) => TSelect;
} = {}) {
  return useQuery({
    queryKey: queryKeys.summary(),
    queryFn: getRecommendationsSummary,
    refetchInterval: 5 * 60 * 1000,
    enabled,
    select,
    ...withError('Unable to load recommendations summary'),
  });
}
